import { Stack } from '@chakra-ui/react'
import { CourseProgressStep } from './CourseProgressStep'

import { Model } from "survey-core";
import { SurveyService } from '../services/SurveyService';
import React from 'react';

export const CourseProgress = (props: {
  model: Model,
  isDisabled?: boolean,
  showMarkup: boolean | undefined
}) => {

  const model = props.model;

  const [currentPageName, setCurrentPageName] = React.useState<string | undefined>(model?.currentPage?.name);

  const steps = React.useMemo(() => {
    return model?.pages.filter(page => page.visible).map(page => {
      const currentPageName = model?.currentPage?.name;
      const info = SurveyService.getPageStatus(model, page.name);
      return {
        title: info.title,
        questionCount: props.showMarkup ? info.questionCount : 0,
        answeredQuestionCount: props.showMarkup ? info.answeredQuestionCount : 0,
        isActive: page.name == currentPageName
      }
    }) ?? [];
  }, [model, model.data, currentPageName]);

  const onClick = (no: number) => {
    if (!props.isDisabled) {
      if (model.tryNavigateToPage(model.pages[no])) {
        setCurrentPageName(model?.currentPage?.name);
      }
    }
  }

  return (
    <Stack w='full' spacing="0" direction={{ base: 'column', md: 'row' }}>
      {steps.map((step, id) => {
        return <CourseProgressStep
          key={id}
          onClick={() => onClick(id)}
          title={step.title}
          isActive={step.isActive}
          questionCount={step.questionCount}
          answeredQuestionCount={step.answeredQuestionCount}
          isFirstStep={id === 0}
          isLastStep={steps.length === id + 1}
        />
      })}
    </Stack>

  )
}